import React, { useState } from 'react';
import HeaderWithBack from '../../components/HeaderWithBack';
import { useNavigate } from 'react-router';
import {toast} from "react-toastify";
import {useRecoilValue} from "recoil";
import {fetchAPIResponseSelector} from "../../store/user.atom";
import {CategoryDTO} from "../../dtos/category.dto";

type Props = {};

const AddCategory: React.FC<Props> = () => {

  const navigate = useNavigate();

  const fetchAPIResponse = useRecoilValue(fetchAPIResponseSelector);

  const [categoryName, setCategoryName] = useState<string>('');
  const [categoryImage, setCategoryImage] = useState<File | null>(null);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setCategoryImage(file);
    }
  };

  const handleDeleteImage = () => {
    setCategoryImage(null);
  };

  const handleAddCategory = async () => {
    if(categoryName === '' || categoryImage == null) {
      toast.error("Fill in contents before creating the category")
      return;
    }

    const formData = new FormData();
    formData.set("name", categoryName);
    formData.set("image", categoryImage, categoryImage.name);

    try {
      await fetchAPIResponse<CategoryDTO>("/categories", {
        method: "POST",
        headers: {
          "Accept": "application/json"
        },
        body: formData
      });

      navigate('/categories')
    } catch (e) {
      toast.error((e as Error).message)
    }
  };

  return (
      <div className='flex flex-col w-full h-full overflow-auto items-center py-10 gap-6'>
        <HeaderWithBack previousPage={'Categories'} currentPage={'Add Category'} previousPageUrl={'/categories'} />
        <div className='zbh-card w-11/12 max-w-2xl p-8'>
          <h2 className="font-display text-base font-semibold text-ink mb-5">New category</h2>
          <label className="zbh-label">Image</label>
          <div className='flex items-center gap-4'>
            <label htmlFor='category-image' className='zbh-btn-ghost cursor-pointer'>
              Choose image
            </label>
            <input type='file' id='category-image' accept='image/*' onChange={handleImageChange} className='hidden' />
            {categoryImage && (
                <div className='flex items-center gap-3'>
                  <img src={URL.createObjectURL(categoryImage)} alt='Category' className='h-14 w-14 rounded-lg object-cover border border-hair' />
                  <button onClick={handleDeleteImage} className='zbh-btn-danger px-4 py-1.5 text-xs'>
                    Remove
                  </button>
                </div>
            )}
          </div>
          <div className="mt-5">
            <label className="zbh-label">Name</label>
            <input type='text' placeholder='e.g. Burgers' value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)} className='zbh-input' />
          </div>
          <button onClick={handleAddCategory} className='zbh-btn-accent w-full mt-6'>
            Add category
          </button>
        </div>
      </div>
  );
};

export default AddCategory;
